import { PencilStroke } from "../api/types";

export function buildPencilLayer(play: { pencil_stroke_list: PencilStroke[] }): string {
  return play.pencil_stroke_list.map(buildStroke).join("\n");
}

function buildStroke(stroke: PencilStroke): string {
  const pts = stroke.points.map((p) => ({
    x: p.x + stroke.offset.width,
    y: p.y + stroke.offset.height,
  }));

  if (pts.length === 0) return "";
  if (pts.length === 1) {
    return `<circle cx="${pts[0].x}" cy="${pts[0].y}" r="${stroke.strokeWidth / 2}"
      fill="${stroke.color}"/>`;
  }
  if (pts.length === 2) {
    return `<path d="M ${pts[0].x} ${pts[0].y} L ${pts[1].x} ${pts[1].y}"
      stroke="${stroke.color}" stroke-width="${stroke.strokeWidth}" fill="none"
      stroke-linecap="round"/>`;
  }

  const mid = (a: { x: number; y: number }, b: { x: number; y: number }) => ({
    x: (a.x + b.x) / 2,
    y: (a.y + b.y) / 2,
  });

  const m01 = mid(pts[0], pts[1]);
  let d = `M ${pts[0].x} ${pts[0].y} L ${m01.x} ${m01.y}`;

  for (let i = 1; i < pts.length - 1; i++) {
    const mNext = mid(pts[i], pts[i + 1]);
    d += ` Q ${pts[i].x} ${pts[i].y} ${mNext.x} ${mNext.y}`;
  }

  d += ` L ${pts[pts.length - 1].x} ${pts[pts.length - 1].y}`;

  return `<path d="${d}" stroke="${stroke.color}" stroke-width="${stroke.strokeWidth}"
    fill="none" stroke-linecap="round" stroke-linejoin="round"/>`;
}
